import React from 'react';

import Helmet from 'react-helmet';

import Header from 'containers/global/application/Header';
import Responsive from 'containers/global/responsive/Responsive';
import Cart from 'containers/pages/accessories/Cart';
import Footer from './footer/Footer';

import './Layout.sass';

interface IProps {
    children: React.ReactNode;
}

// Attempts to set a default Canonical link to avoid duplicate page errors in google search console.
// You can override the default canonical link by inserting another Helmet element further down in the component hierarchy.
const CanonicalLink: React.StatelessComponent<{}> = () => {
    // Don't include the query string in the canonical link
    const { location } = window;
    const defaultCanonical = location.protocol + '//' + location.host + location.pathname;

    return (
        <Helmet>
            <link rel="canonical" href={defaultCanonical} />
        </Helmet>
    );
};

const ApplicationLayout: React.StatelessComponent<IProps> = ({ children }) => {
    const renderCart = () => {
        if (
            location.pathname === '/accessories/cart'
            || location.pathname === '/accessories/thankyou'
        ) {
            return;
        }
        return <Cart />;
    };

    return(
        <div id="App" className="container-fluid App">
            <CanonicalLink />
            <Responsive>
                <Header />
                {renderCart()}
                {children}
                <Footer />
            </Responsive>
        </div>
    );
};

export default ApplicationLayout;



// WEBPACK FOOTER //
// ./src/components/global/application/Layout.tsx